import type { QueryKey } from "@tanstack/react-query";

/** Racine commune des caches métier isolés par domaine. */
const TENANT_QUERY_ROOT = "tenant" as const;

/**
 * Construit une clé React Query explicitement scopée au domaine courant.
 *
 * `domaineId` peut être nul pendant la résolution de session : la clé reste
 * alors distincte, mais l'appelant DOIT aussi poser `enabled: Boolean(domaineId)`.
 * Le domaine sert uniquement d'espace de noms local ; il n'est jamais envoyé
 * à l'API comme preuve d'autorisation.
 */
export function tenantQueryKey(
  domaineId: string | null | undefined,
  ...segments: QueryKey
): readonly [typeof TENANT_QUERY_ROOT, string | null, ...QueryKey] {
  return [TENANT_QUERY_ROOT, domaineId?.trim() || null, ...segments];
}

/** Clé racine permettant d'invalider un domaine sans toucher aux autres. */
export function tenantQueryRootKey(
  domaineId: string | null | undefined,
): readonly [typeof TENANT_QUERY_ROOT, string | null] {
  return [TENANT_QUERY_ROOT, domaineId?.trim() || null];
}

/**
 * Construit une clé de stockage navigateur isolée par domaine.
 * Retourne `null` tant que le tenant n'est pas résolu (lecture/écriture fermée).
 */
export function tenantStorageKey(
  baseKey: string,
  domaineId: string | null | undefined,
): string | null {
  const scope = domaineId?.trim();
  if (!scope) return null;
  return `${baseKey}:${encodeURIComponent(scope)}`;
}
